import React from "react";
import { Link } from "gatsby";
import _ from "lodash";
import Container from "./container";
import IntegrationContactForm from "./integration-contact-form";
import mergeDataset from "../common/mergeDataset";
import processFlow from "../common/processFlow";

import * as styles from "../styles/components/main-content-integration.module.css";

const IntegrationMain = (props) => {
  const { name, appIntegrations: appInts } = props;

  const appIntegrations = appInts
    .filter((integration) => integration.name !== "Data Routing")
    .map((integration) => {
      const mappedInts = integration.flows
        .map((flowType) => processFlow(flowType, name))
        .filter(Boolean);
      return {
        name: integration.name,
        integrations: mergeDataset(mappedInts),
      };
    });

  return (
    <div className={styles.root}>
      <Container>
        <div className={styles.gridContainer}>
          {appIntegrations.map((int) => {
            return (
              <div className={styles.gridItem} key={int.name}>
                <h5>{int.name}</h5>
                <div className={styles.integrationCategory}>
                  <table className={styles.table}>
                    <tbody className={styles.integrationTableBody}>
                      {int.integrations.map(({ to = {} }) =>
                        to.systems?.length ? (
                          <tr key={to.title}>
                            <table>
                              <thead>
                                <h6>{to.title} To:</h6>
                              </thead>
                              <tbody>
                                {to.systems.map((sys) => (
                                  <tr key={sys.name}>
                                    <Link
                                      to={`/integrations/${
                                        sys.slug ||
                                        sys.name
                                          .toLowerCase()
                                          .replace(/ /g, "-")
                                      }`}
                                      target="_blank"
                                    >
                                      {sys.name}
                                    </Link>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </tr>
                        ) : null
                      )}
                      {int.integrations.map(({ from = {} }) =>
                        from.systems?.length ? (
                          <tr key={from.title}>
                            <table>
                              <thead>
                                <h6>{from.title} From:</h6>
                              </thead>
                              <tbody>
                                {from.systems.map((sys) => (
                                  <tr key={sys.name}>
                                    <Link
                                      to={`/integrations/${
                                        sys.slug ||
                                        sys.name
                                          .toLowerCase()
                                          .replace(/ /g, "-")
                                      }`}
                                      target="_blank"
                                    >
                                      {sys.name}
                                    </Link>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </tr>
                        ) : null
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles.category}>
          <h4>Interested In This Integration?</h4>
          <p>Complete this form and we'll be in touch to get you started.</p>
          <IntegrationContactForm />
        </div>
        <div className={styles.disclaimer}>
          All logos on this page are owned by their respective trademark owners.
          Any usage of logos or other references to software not owned or
          produced by Chain.io does not imply endorsement from the software
          owner. Chain.io does not warrant or represent the suitability of any
          external software for any purpose.
        </div>
      </Container>
    </div>
  );
};

export default IntegrationMain;
